module.exports = __webpack_public_path__ + "static/buddyleeabbybrett-a2519f417bfbad20d9ddc4b7f4f2b652.jpg";